import {CALL_API} from 'redux/middleware/api'
import {
  USER_ADD,
  USERS
} from './'
import {reportError} from 'redux/modules/error/actions'

export function fetchUsers() {
  return dispatch => dispatch({
    [CALL_API]: {
      endpoint: 'users',
      errorsHandled: true,
      types: USERS
    }
  })
}

export function addUser({name, phone, email, verify = true}) {
  return dispatch => dispatch({
    [CALL_API]: {
      endpoint: 'users',
      errorsHandled: true,
      method: 'POST',
      types: USER_ADD,
      body: {name, phone, email, verify}
    }
  })
    .success(() => dispatch(fetchUsers()))
    .fail(dispatch(reportError()))
}

export function updateUser({userId, name, email}) {
  return null
}

export function deleteUser(userId) {
  return null
}



// WEBPACK FOOTER //
// ./client/redux/modules/users/actions.js